import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { Icon } from '@yes.technology/react-toolkit'
import styled from 'styled-components'

import { isEmbedded } from '../../../utils/helpers/iframe'

const ComponentStrucuture = styled.div`
  display: flex;
  align-items: center;

  span {
    flex: 1;
  }
`

const IconButton = styled.button`
  background: transparent;
  border: none;

  &:focus {
    box-shadow: unset !important;
  }

  &:hover {
    opacity: 0.8;
  }
`

const EnvironmentWarning = () => {
  const [isShow, setIsShow] = useState(true)
  const { t } = useTranslation()
  const env = window.waEnv
  const isProductionEnv = env === 'production'

  if (isEmbedded() || !isShow || isProductionEnv) return null

  return (
    <ComponentStrucuture className='alert alert-danger rounded-0 mb-0 text-center'>
      <span>{t('system.warning-env', { env })}</span>
      <IconButton onClick={() => setIsShow(false)}>
        <Icon iconName='Close' icSize='small' />
      </IconButton>
    </ComponentStrucuture>
  )
}

export default EnvironmentWarning
